<template>
  <el-card shadow="alway" class="crm-card-box" :body-style="{ padding: '0px' }">
    <img :src="require(`@/assets/svg/coupon-out.svg?inline`)" v-if="!isLoading && !this.promotion.haveQuota" class="crm-card-coupon-badge" alt="" />
    <el-row v-if="!isLoading">
      <el-col :span="8">
        <div
          :id="id"
          class="crm-card-menu-img"
          :style="{
            'background-image': `
                linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 38%, rgba(255,255,255,1) 100%),
                url(${this.crm_public_path}${this.promotion.imageKey})`,
          }"
        />
      </el-col>
      <el-col :span="16" class="py-4">
        <div class="px-4">
          <label class="crm-card-name text-1-line">{{ promotion.name }}</label>
          <label class="crm-card-descript text-2-line">{{
            promotion.detail
          }}</label>
        </div>
        <!-- โปรที่เป็นสิทธิพิเศษ -->
        <div class="crm-card-entry-point pt-1 px-4" v-if="promotion.isPrivilege">
          <Privilege />
          <label class="mt--1 crm-card-point">
            {{ $t('components.history.privilege') }}
          </label>
        </div>
        <!-- โปรที่เป็น point -->
        <div class="crm-card-entry-point pt-1 px-4" v-else>
          <points />
          <label class="crm-card-point">
            {{ numberWithCommas(promotion.point) }} {{ $t('components.history.point') }}</label
          >
        </div>
      </el-col>
    </el-row>
    <el-skeleton v-else animated>
      <template #template>
        <el-row>
          <el-col :span="8">
            <el-skeleton-item
              variant="image"
              class="crm-card-menu-img"
            />
          </el-col>
          <el-col :span="16" class="py-4">
            <div class="px-4">
              <el-skeleton-item variant="p" class="crm-card-name" style="width: 60%" />
              <div class="crm-card-descript">
                <el-skeleton-item variant="p" style="width: 30%" />
              </div>
            </div>
            <div class="crm-card-entry-point pt-1 px-4">
              <el-skeleton-item
                variant="p"
                style="width: 15%;"
              />
            </div>
          </el-col>
        </el-row>
      </template>
    </el-skeleton>
  </el-card>
</template>

<script>
import Points from "@/components/icons/Points.vue";
const Privilege = () => import("@/assets/svg/privilege.svg")
import mixins from "@/helper/mixins";

export default {
  mixins: [mixins],
  components: { Points,Privilege },
  props: {
    isLoading: Boolean,
    promotion: {
      type: Object,
    },
  },
  data() {
    return {
      crm_public_path: process.env.VUE_APP_S3_PUBLIC_PATH,
      id: `promo-card-${this.$vnode.key}`,
    };
  },
};
</script>

<style scoped>
.crm-card-box {
  height: 112px;
  background: #ffffff;
  box-shadow: 0px 4px 14px rgba(106, 113, 128, 0.1);
  border-radius: 12px;
  border: none;
  margin-bottom: 12px;
}

.crm-card-menu-img {
  width: 100%;
  height: 120px;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center;
}

.crm-card-entry-descript {
  padding: 16px 0;
}

.crm-card-entry-point {
  display: flex;
}

.crm-card-name {
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: #333333;
}

.crm-card-descript {
  height: 38px;
  color: #828282;
  font-size: 16px;
  font-weight: lighter;
}

.crm-card-point {
  color: var(--primary);
  font-size: 20px;
  margin-left: 5px;
  margin-top: -3px;
}

.mt--1 {
  margin-top: -1px;
}

.crm-card-coupon-badge {
    position: absolute;
    left: 0px;
    z-index: 1;
    margin-left: 10px;
    margin-top: 10px;
}
</style>
